module.exports = __webpack_public_path__ + "img/down.6c7bf9df.svg";